<template>
  <div>
    <a-select
      v-model="model.po_id"
      class="ts-w-full"
      :options="purchase"
      showSearch
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      @change="purchaseOrderChange"
    ></a-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'purchaseOrderNumber',
  props: ['value'],
  data () {
    return {
      model: {}
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapGetters('stock/stockIn', ['isExpirable']),
    purchase () {
      return this.$store.state.stock.stockIn.purchaseorders.map(el => ({
        value: el.po_id,
        label: el.po_number
      }))
    }
  },
  methods: {
    purchaseOrderChange (value) {
      this.$emit('loading', true)
      this.$store
        .dispatch('stock/stockIn/purchaseorderList', value)
        .then(response => {
          this.setData(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    setData (data) {
      this.model.vendor_id = data.vendor_id
      this.model.credit_day = data.credit_day
      this.model.purchase_type_id = data.purchase_type_id
      this.model.product_detail = []
      data.details.forEach(el => {
        this.model.product_detail.push({
          product_id: el.product_id,
          uom_id: el.uom_id,
          qty: el.quantity_order - el.quantity_received,
          cost: el.cost ? el.cost : 0,
          discount_rate: el.discount_rate,
          discount_type: el.discount_type,
          total_after_discount: el.total_after_discount,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: el.total_after_discount,
          expiry_date: null,
          is_expire: this.isExpirable(el.product_id),
          product_grade: ''
        })
      })
    }
  }
}
</script>
